import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { ButtonEx } from '@xylabs/sdk-react'
import { useNavigate } from 'react-router-dom'

interface MessageDialogProps {
  open?: boolean
  title?: string
}

const GeotokenNotExistDialogOpen: React.FC<MessageDialogProps> = (props) => {
  const { title = 'Geotoken does not exist', open = false } = props
  const navigate = useNavigate()

  const onCloseClicked = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    navigate(-1)
  }

  return (
    <Dialog onClose={onCloseClicked} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Sorry, this geotile does not seem to exist yet.</Typography>
      </DialogContent>
      <DialogActions>
        <ButtonEx onClick={onCloseClicked} variant="text">
          Back
        </ButtonEx>
        <ButtonEx to="/" variant="text">
          Home
        </ButtonEx>
      </DialogActions>
    </Dialog>
  )
}

const GeotokenNotExistDialog: React.FC<MessageDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <GeotokenNotExistDialogOpen {...props} />
  } else {
    return null
  }
}

export default GeotokenNotExistDialog
